import React from 'react';
export function Button({
  children,
  href,
  className = '',
  size = 'default'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'default' | 'large' | 'small';
}) {
  const sizeClasses = {
    small: 'py-2.5 px-6 text-sm',
    default: 'py-4 px-10 text-base',
    large: 'py-5 px-12 text-lg'
  };
  const baseClasses = `btn-sweep inline-flex items-center justify-center gap-2.5 bg-gradient-to-r from-accent via-accent-light to-accent-dark bg-[length:300%_100%] animate-btn-gradient text-primary font-sans font-extrabold rounded-md border-none cursor-pointer no-underline transition-all duration-300 whitespace-nowrap tracking-wide hover:scale-105 hover:shadow-[0_12px_40px_rgba(232,160,32,0.5)] hover:brightness-110 ${sizeClasses[size]} ${className}`;
  if (href) {
    return <a href={href} className={baseClasses} data-id="element-399">
        {children}
      </a>;
  }
  return <button className={baseClasses} data-id="element-400">{children}</button>;
}
export function Tag({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="inline-block bg-accent/15 text-accent border border-accent/30 py-1.5 px-4 rounded-full text-xs font-bold tracking-widest uppercase mb-5" data-id="element-401">
      {children}
    </span>;
}
export function SectionHeader({
  tag,
  title,
  subtitle,
  titleClassName = ''
}: {
  tag?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  titleClassName?: string;
}) {
  return <div className="text-center" data-id="element-402">
      {tag && <Tag data-id="element-403">{tag}</Tag>}
      <h2 className={`font-playfair text-3xl md:text-4xl lg:text-5xl font-black leading-tight mb-4 ${titleClassName}`} data-id="element-404">
        {title}
      </h2>
      <div className="w-16 h-1 bg-gradient-gold mx-auto my-6 rounded-sm" data-id="element-405"></div>
      {subtitle && <p className="text-text-muted text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-406">
          {subtitle}
        </p>}
    </div>;
}